<template>
    <el-dialog
        :title="dialogTitle"
        :visible.sync="addEditDepartmentDialog"
        width="520px"
        :before-close="handleDepartmentClose"
        :close-on-click-modal="false"
        class="custom-form-dialog"
    >
        <el-form ref="departmentForm" :rules="departmentFormRules" :model="departmentForm" label-position="top">
            <el-form-item label="部门名称" prop="department">
                <el-input
                    placeholder="请输入部门名称"
                    v-model="departmentForm.department"
                    :maxlength="10"
                    clearable
                ></el-input>
            </el-form-item>
            <el-form-item label="上级部门" prop="did">
                <el-select
                    placeholder="请选择上级部门"
                    ref="department_select"
                    v-model="departmentForm.didTitle"
                    :remote-method="getDepartmentList"
                    filterable
                    remote
                    reserve-keyword
                    :disabled="departmentInfo.pid == 0"
                >
                <!-- !departmentInfo.id -->
                    <el-option :value="departmentForm.didTitle" style="height: auto; padding: 0">
                        <el-tree
                            :data="depOptions"
                            :expand-on-click-node="false"
                            :props="defaultProps"
                            @node-click="handleClickDepNode"
                            check-on-click-node
                            check-strictly
                            default-expand-all
                            node-key="id"
                            ref="depTree"
                        >
                        </el-tree>
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="部门负责人" prop="department_heads">
                <el-select
                    :remote-method="getUserList"
                    class="el_select_change"
                    multiple
                    :multiple-limit="1"
                    filterable
                    @hook:mounted="cancalReadOnly()"
                    @visible-change="cancalReadOnly()"
                    placeholder="请选择部门负责人"
                    remote
                    v-model="departmentForm.department_heads"
                >
                    <el-option v-for="(user, index) in userList" :key="user.uid" :label="user.name" :value="user.uid">
                    </el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click.stop="handleDepartmentClose">取消</el-button>
            <el-button type="primary" :disabled="btnDisabled" @click.stop="handleDepartmentConfirm">确定</el-button>
        </span>
    </el-dialog>
</template>
<script>
import { GetCompanyDepartmentList, DepartmentAdd, DepartmentEdit, GetUserList } from "@/api";
export default {
    name: "editDepartment",
    props: {
        addEditDepartmentDialog: {
            type: Boolean,
            default: false,
        },
        dialogType: {
            type: String,
            default: "",
        },
        departmentInfo: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            departmentForm: {
                department: "",
                didTitle: "",
                did: "",
                department_heads: [],
            },
            departmentFormRules: {
                department: [{ required: true, message: "请输入部门名称", trigger: "blur" }],
            },
            depOptions: [],
            userList: [],
            btnDisabled: false,
            defaultProps: {
                children: 'children', 
                label: 'department_name',
                disabled: (data)=> {
                    return data.level >= this.departmentInfo.level
                }
            }
        };
    },
    computed: {
        dialogTitle() {
            let title = "新建部门";
            if (this.dialogType == "add") {
                title = this.departmentInfo && this.departmentInfo.id ? "添加子部门" : "新建部门";
            } else if (this.dialogType == "edit") {
                title = "编辑部门";
            }
            return title;
        },
    },
    created() {
        if (this.departmentInfo && this.departmentInfo.id && this.dialogType == "edit") {
            //是编辑
            this.departmentForm.department = this.departmentInfo.department_name;
            if(this.departmentInfo.pid == 0) {
                // 一级部门
                this.departmentForm.didTitle = this.departmentInfo.department_name;
            } else {
                this.departmentForm.didTitle = this.departmentInfo.pid_department_name;
            }
            this.departmentForm.did = this.departmentInfo.pid;
            this.departmentForm.department_heads = this.departmentInfo.heads.map((map) => {
                return map.uid;
            });
            if (this.departmentInfo.heads.length == 0) {
                this.getUserList();
            } else {
                this.userList = this.departmentInfo.heads;
            }
        }
        if (this.departmentInfo && this.dialogType == "add") {
            //是添加子部门
            this.departmentForm.didTitle = this.departmentInfo.department_name;
            if (this.departmentInfo.id) {
                this.departmentForm.did = this.departmentInfo.id;
            }
        }
        if (this.dialogType != "edit") {
            this.getUserList();
        }
        this.getDepartmentList();
    },
    methods: {
        handleDepartmentShow() {
            this.$emit("update:addEditDepartmentDialog", true);
        },
        handleDepartmentClose() {
            this.$emit("update:addEditDepartmentDialog", false);
        },

        // 部门搜索
        getDepartmentList(title) {
            GetCompanyDepartmentList().then((res) => {
                if (res.code === 200) {
                    this.depOptions = res.data.departments || [];
                } else {
                    this.$message.error(res.message);
                }
            });
        },
        // 点击部门树节点
        handleClickDepNode(data, node, nodeData) {
            if(data.level > this.departmentInfo.level) return this.$message.error("不能选择子部门当上级部门");
            this.departmentForm.didTitle = data.department_name;
            this.departmentForm.did = data.id;
            this.$refs.department_select.handleClose();
        },
        getUserList(keyword) {
            GetUserList({ keyword }).then((res) => {
                if (res.code == 200) {
                    this.userList = res.data || [];
                }
            });
        },
        cancalReadOnly(onOff) {},
        handleDepartmentConfirm() {
            this.$refs.departmentForm.validate((valid) => {
                if (valid) {
                    if (this.dialogType == "edit") {
                        let postData = {
                            id: this.departmentInfo.id,
                            department_name: this.departmentForm.department,
                            pid: this.departmentForm.did,
                            department_heads: this.departmentForm.department_heads,
                        };
                        this.btnDisabled = true;
                        DepartmentEdit(postData).then((res) => {
                            if (res.code === 200) {
                                this.$message({
                                    type: "success",
                                    message: res.message,
                                    duration: 1500,
                                    onClose: () => {
                                        this.btnDisabled = false;
                                        this.$emit("success");
                                        this.handleDepartmentClose();
                                    },
                                });
                            } else {
                                this.btnDisabled = false;
                                // this.$message.error(res.message);
                            }
                        });
                    } else {
                        let postData = {
                            department_name: this.departmentForm.department,
                            pid: this.departmentForm.did || 0,
                            department_heads: this.departmentForm.department_heads,
                        };
                        this.btnDisabled = true;
                        DepartmentAdd(postData).then((res) => {
                            if (res.code === 200) {
                                this.$message({
                                    type: "success",
                                    message: res.message,
                                    duration: 1500,
                                    onClose: () => {
                                        this.btnDisabled = false;
                                        this.$emit("success");
                                        this.handleDepartmentClose();
                                    },
                                });
                            } else {
                                this.btnDisabled = false;
                                // this.$message.error(res.message);
                            }
                        });
                    }
                }
            });
        },
    },
};
</script>
